const sidebarNav = [
  {
    link: "/",
    section: "dashboard",
    icon: "lucide:layout-dashboard", //width:"20"
    text: "Dashboard",
  },
  {
    link: "/products",
    section: "products",
    icon: "icon-park-outline:ad-product",
    text: "Products",
  },
  {
    link: "/customers",
    section: "customers",
    icon: "ph:users-bold",
    text: "Customers",
  },
  {
    link: "/orders",
    section: "orders",
    icon: "icon-park-outline:transaction-order",
    text: "Orders",
  },
  {
    link: "/analytics",
    section: "analytics",
    icon: "carbon:analytics",
    text: "Analytics",
  },
  {
    link: "/discount",
    section: "discount",
    icon: "nimbus:discount-circle",
    text: "Discount",
  },
  {
    link: "/inventory",
    section: "inventory",
    icon: "ic:round-inventory",
    text: "Inventory",
  },
];

export default sidebarNav;
